import React, { useState } from 'react';
import PropTypes from 'prop-types';

import NotificationContext from './NotificationContext';
import Notification from './Notification';

const NotificationProvider = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState(null);

    const showNotification = (newMessage, newError) => {
        setMessage(newMessage);
        setError(newError);
        setIsOpen(true);
    };

    const hideNotification = () => {
        setMessage('');
        setError(false);
        setIsOpen(false);
    };

    return (
        <NotificationContext.Provider
            value={{
                showNotification,
                hideNotification,
                notificationIsShowing: isOpen,
                message,
                error
            }}
        >
            <Notification />
            {children}
        </NotificationContext.Provider>
    );
};

NotificationProvider.propTypes = {
    children: PropTypes.node.isRequired
};

export default NotificationProvider;
